module.exports = __webpack_public_path__ + "img/LogoDashboard-30.c266c901.svg";